<template>
  <navBar/>
  <div class="content">
    <router-view/>
  </div>
</template>

<script lang="ts" setup>
import navBar from "@/components/navbar.vue";
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  padding-left: 76px;
  width: calc(100% - 76px);
}
</style>
